<template>
  <div>
    <button class="d-none" data-toggle="modal" data-target="#manageSeedars" ref="openModalManageSeedars"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="manageSeedars">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">Manage Event Seed Criteria</h6>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeManageSeedars">
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <SeedingComponent :eventId="eventId" :association_id="association_id" @update-state="handleStateUpdate"/>
          </div>
          <div class="event-btns-wrapper pt-3 justify-content-end">
            <button v-if="this.isDisabled == false" type="button" class="btn btn-primary" block
              @click="manageSeedars(0)" :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save</div>
            </button>
            <button v-else-if="this.isDisabled == true" type="button" class="btn btn-primary-disabled"
              :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Save</div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <FlashMessage
      :position="'right bottom'"
      style="z-index: 99999999 !important"
    ></FlashMessage>
  </div>
</template>
<script>
import axios from "axios";
import SeedingComponent from "./SeedingComponent.vue";
export default {
  name: "ManageEventSeedars",
  components: {
    SeedingComponent
  },
  // props: {
  //   eventId: {
  //     type: [Number, String],
  //   },
  //   association_id: {
  //     type: [Number, String],
  //   },
  // },
  data() {
    return {
      isDisabled: true,
      isLoadingArray: [],
      selectedSeedarsFromChild: [],
      eventId: null,
      association_id: null
    };
  },

  methods: {
    handleStateUpdate({ isDisabled, selectedSeedars }) {
      this.isDisabled = isDisabled;
      this.selectedSeedarsFromChild = selectedSeedars;
    },
    closeModal() {
      var elem = this.$refs.closeManageSeedars;
      if (elem) {
        elem.click();
      }
    },
    async manageSeedars(index) {
      this.$set(this.isLoadingArray, index, true); // Show loading indicator

      try {
        const url = `${process.env.VUE_APP_API_URL}associationEvent/updateEventSeedCriteria`;
        const response = await axios.post(url, {
          event_id: this.eventId,
          association_id: this.association_id,
          seed_criteria_defaults: this.selectedSeedarsFromChild,
        });

        // Check the response and handle accordingly
        if (response.data.statusCode === 200) {
          // Success case
          this.$root.$emit("fetchUpdatedSeedCriteria");
          this.$root.$emit("fetchEventDataOnEdit");
          this.closeModal();
          this.flashMessage.success({
            title: 'Success',
            message: response.data.message,
            time: 5000,
            blockClass: "custom-block-class",
          });
        } else if (response.data.statusCode === 404) {
          this.closeModal();
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: 'Teams' });
        } else {
          this.closeModal();
          this.$alert('Failed to update seed criteria. Please try again later.', 'Error');
        }
      } catch (error) {
        console.error("Error saving selected Seeding:", error);
        this.$alert('An unexpected error occurred. Please try again later.', 'Error');
      } finally {
        this.$set(this.isLoadingArray, index, false);
      }
    },
  },

  mounted() {
    this.$root.$on("openManageEventSeedarsModal", (params) => {
      // Destructure the parameters
      const { eventId, association_id } = params || {};

      // Store these values if needed
      this.eventId = eventId;
      this.association_id = association_id;
      var elem = this.$refs.openModalManageSeedars;
      if (elem) {
        elem.click();
      }
    });
  },
};
</script>